<template>
    <div>
        <menu-bar v-if="menu"/>
        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a href="#/caixas-emendas"><i class="fa fa-suitcase" aria-hidden="true"></i> CAIXAS DE EMENDAS</a></li>
                    <li class="active">CADASTRO DE CAIXA DE EMENDA</li>
                </ol>

                <go-back v-if="menu" :url="'#/caixas-emendas'"/><br v-if="menu"/><br v-if="menu"/>

                <form class="form-horizontal" >

                    <div class="panel panel-info">
                        <!-- Default panel contents -->
                        <div class="panel-heading">
                            <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                        </div>

                        <div class="panel-body">
                            <div class="form-group">

                                <div class="col-sm-12">
                                    <label for="nome" class="control-label">OBS DA CAIXA</label>
                                    <textarea id="nome" v-model.number="reserva.obs" class="form-control" ></textarea>
                                </div>

                            </div>
                        </div>
                    </div>

                    <place :place.sync="reserva.place" :height="'500px'" />

                    <div class="form-group">
                        <div class="col-sm-10">
                            <button type="button" v-if="user.level < 5"
                                    @click="save()"
                                    class="btn btn-success">
                                <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR CAIXA DE EMENDA
                            </button>
                        </div>
                    </div>

                </form>

            </div>
        </div>

    </div>
</template>
<script>
import { CaixaEmenda } from "../../../class/index";
import { VoltarMenu, Place } from "../../../components/exports";
import GoBack from "../../../components/buttons/goback";

export default {
    components: { VoltarMenu, Place, GoBack },
    data() {
        return {
            user: null,
            menu: true,
            reserva: CaixaEmenda.create()
        };
    },
    computed: {
        _id() {
            return this.$route.params.id;
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.query.disable_menu === "1") {
            this.menu = false;
        }
        if (this._id) {
            this.loadPonto(this.$route.params.id);
        } else if (this.$route.params.lat && this.$route.params.lng) {
            this.reserva = CaixaEmenda.create();
            this.reserva.place = [
                Number(this.$route.params.lng),
                Number(this.$route.params.lat)
            ];
            this.menu = false;
        }
    },
    beforeDestroy() {
        console.log("reserva tecnica off");
    },
    methods: {
        async loadPonto() {
            this.reserva = await CaixaEmenda.byID(this._id);
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar a reserva?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            CaixaEmenda.save(this.reserva)
                                .then(() => {
                                    resolve();
                                    if (this.menu) {
                                        this.$router.push({
                                            path: "/caixas-emendas"
                                        });
                                    } else {
                                        window.close();
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
